import VueCqrs from '@cqrs/vue-component-cqrs';
import * as c from '@Projects/Domain/commands-core';
import { ProjectTemplateLink } from '@Projects/Model';
import Component from 'vue-class-component';

@Component
export default class ProjectCommands extends VueCqrs {

	invokeCreateProjectUsersTagCommandV1(workspaceId: number, projectId: number, tag: string)
	{
		const cmd = new c.CreateProjectUsersTagCommandV1(workspaceId, projectId, tag);
		this.$command(cmd, tag);
	}

	invokeExportProjectCommandV1(id: string) {
		const cmd = new c.ExportProjectCommandV1(id);
		this.$command(cmd);
	}

	invokeDeleteProjectUsersTagCommandV1(workspaceId: number, projectId: number, tag: string)
	{
		const cmd = new c.DeleteProjectUsersTagCommandV1(workspaceId, projectId, tag);
		this.$command(cmd, tag);
	}

	invokeUpdateProjectUsersTagCommandV1(workspaceId: number, projectId: number, oldTag: string, newTag: string)
	{
		const cmd = new c.UpdateProjectUsersTagCommandV1(workspaceId, projectId, oldTag, newTag);
		this.$command(cmd, oldTag);
	}

	invokeUpdateProjectCommandV1(workspaceId: number, projectId: number, name: string, desc: string)
	{
		const cmd = new c.UpdateProjectCommandV1(workspaceId, projectId, name, desc);
		this.$command(cmd, projectId.toString());
	}

	invokeCreatePortfolioProjectCommandV1(workspaceId: number, name: string, desc: string)
	{
		const cmd = new c.CreatePortfolioProjectCommandV1(workspaceId, name, desc);
		this.$command(cmd, name);
	}

	invokeCreateDecisionProjectCommandV1(workspaceId: number, name: string, desc: string)
	{
		const cmd = new c.CreateDecisionProjectCommandV1(workspaceId, name, desc);
		this.$command(cmd, name);
	}


	invokeDeleteProjectCommandV1(workspaceId: number, projectId: number)
	{
		const cmd = new c.DeleteProjectCommandV1(workspaceId, projectId);
		this.$command(cmd, projectId.toString());
	}

	invokeCloneProjectCommandV1(workspaceId: number, sourceProjectId: number, cloneName: string)
	{
		const cmd = new c.CloneProjectCommandV1(workspaceId, sourceProjectId, cloneName);
		this.$command(cmd, cloneName);
	}

	invokeUpdateProjectTemplateLinksCommandV1(workspaceId: number, projectId: number, links: ProjectTemplateLink[])
	{
		const cmd = new c.UpdateProjectTemplateLinksCommandV1(workspaceId, projectId, links);
		this.$command(cmd, projectId.toString());
	}

	invokeSwitchProjectWorkspaceCommandV1(sourceWorkspaceId: number, projectId: number, targetWorkspaceId: number)
	{
		const cmd = new c.SwitchProjectWorkspaceCommandV1(sourceWorkspaceId, projectId, targetWorkspaceId);
		this.$command(cmd, projectId.toString());
	}

	invokeDownloadProjectTemplateCommandV1(workspaceId: number, sourceProjectId: number, sourceProjectTemplateLinkId: number)
	{
		const cmd = new c.DownloadProjectTemplateCommandV1(workspaceId, sourceProjectId, sourceProjectTemplateLinkId);
		this.$command(cmd, sourceProjectTemplateLinkId.toString());
	}
}
